import { Injectable } from "@angular/core";
import { Constant } from '../constants/constant';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class PagesService {
    constructor(
        private http_client: ApiService,
    ) { }

    // internal notes
    async getDataAccounts(clientName: string): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/InternalNotes/client/${clientName}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getNoteDetails(id: number): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/InternalNotes/${id}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteAccount(data: any): Promise<any> {
        try {
            const response = await this.http_client.deleteData(Constant.new_base_url
                + `api/InternalNotes`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async insertAccount(data: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/InternalNotes`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateAccount(data: any): Promise<any> {
        try {
            const response = await this.http_client.putData(Constant.new_base_url
                + `api/InternalNotes`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    // contacts
    async getDataContacts(clientName: any): Promise<any> {

        try {
            console.log('link', Constant.new_base_url
                + `api/Contacts/client/${clientName}`)
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/Contacts/client/${clientName}`)

            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteContact(contact: any): Promise<any> {

        try {
            const response = await this.http_client.deleteData(Constant.new_base_url
                + `api/Contacts`, contact);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async InsertContact(data: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/Contacts`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateContact(data: any): Promise<any> {

        try {
            const response = await this.http_client.putData(Constant.new_base_url
                + `api/Contacts/`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getContactList(): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/List/Division`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getContactDetails(first_name: string, last_name: string): Promise<any> {

        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/Contacts/${first_name}&${last_name}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }


    // line authority 
    async getLineAuthorities(clientName: string): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url +
                `api/LineAuthority/client/${clientName}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteLineAuthority(data: any): Promise<any> {
        try {
            const response = await this.http_client.deleteData(Constant.new_base_url +
                `api/LineAuthority`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async insertLineAuthority(data: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url +
                `api/LineAuthority`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateLineAuthority(data: any): Promise<any> {
        try {
            const response = await this.http_client.putData(Constant.new_base_url +
                `api/LineAuthority`, data)
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getLineAuthoritiesById(lineId: number): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url +
                `api/LineAuthority/${lineId}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    // posted collateral
    async getPostedCollateral(clientName: string): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url +
                `api/PostedCollateral/client/${clientName}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deletePostedCollateral(data: any): Promise<any> {
        try {
            const response = await this.http_client.deleteData(Constant.new_base_url +
                `api/PostedCollateral`, data);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async insertPostedCollateral(data: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url +
                `api/PostedCollateral`, data)
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updatePostedCollateral(data: any): Promise<any> {
        try {
            const response = await this.http_client.putData(Constant.new_base_url +
                `api/PostedCollateral`, data)
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getPostedCollateralById(id: number): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url +
                `api/PostedCollateral/${id}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
}